import React from "react";
import { Box, Typography } from "@mui/material";
import { getResponsiveSize } from "../../utils/responsive";
import globalStyles from "../../global";

const imageBaseUrl = process.env.REACT_APP_IMAGE_BASE_URL;

const steps = [
  {
    number: "01",
    text: "We pick up your garments without physical contact, ensuring complete safety.",
  },
  {
    number: "02",
    text: "Following daily health checks, staff sanitize and handle all items with care.",
  },
  {
    number: "03",
    text: "Every order is washed separately using disinfectants.",
  },
  {
    number: "04",
    text: "Clothes are dried at high temperatures to kill 99.9% of bacteria.",
  },
  {
    number: "05",
    text: "Sanitized, fresh clothing is packed and delivered safely.",
  },
];

const SafetyTimeline = () => {
  return (
    <Box sx={{ width: "100%", py: getResponsiveSize(4), mt: 8 }}>
      <Box
        sx={{
          width: "100%",
          maxWidth: "1200px",
          mx: "auto",
          px: { xs: 2, md: 4 },
          textAlign: "center",
        }}
      >
        <Typography
          variant="h1"
          sx={{
            fontSize: { md: "40px", sm: "30px", xs: "26px" },
            fontFamily: globalStyles.fonts.primaryUAE,
            fontWeight: 400,
            textTransform: "uppercase",
            mb: 2,
            textAlign: "center",
          }}
        >
          The UClean Way to Cleaner, Safer Clothes
        </Typography>

        {/* ---------- Desktop Timeline ---------- */}
        <Box
          sx={{
            position: "relative",
            display: { xs: "none", md: "flex" },
            justifyContent: "center",
            mt: "10%",
          }}
        >
          <img
            src={`${imageBaseUrl}safetyTimeline.png`}
            alt="timeline"
            style={{
              width: "16%",
              height: "auto",
            }}
          />

          {steps.map((step, index) => {
            const topOffset = `${index * 210 + 20}px`;
            const isEven = index % 2 === 0;

            return (
              <React.Fragment key={index}>
                {/* Number */}
                <Typography
                  sx={{
                    position: "absolute",
                    top: `calc(${topOffset})`,
                    transform: "translateY(-50%)",
                    left: isEven ? "0%" : "unset",
                    right: !isEven ? "0%" : "unset",
                    fontFamily: "AllRoundGothic-Bold",
                    fontWeight: 400,
                    fontSize: "200px",
                    lineHeight: "100%",
                    letterSpacing: "-5%",
                    textTransform: "uppercase",
                    color: "#F2F3F0",
                    zIndex: 2,
                    pointerEvents: "none",
                  }}
                >
                  {step.number}
                </Typography>

                {/* Text */}
                <Typography
                  sx={{
                    position: "absolute",
                    top: topOffset,
                    transform: "translateY(-50%)",
                    right: isEven ? "-0px" : "unset",
                    left: !isEven ? "-0px" : "unset",
                    fontFamily: "Poppins",
                    fontWeight: 600,
                    fontSize: "16px",
                    lineHeight: "24px",
                    letterSpacing: "0",
                    maxWidth: "200px",
                    textAlign: isEven ? "left" : "right",
                    color: "#003A26",
                  }}
                >
                  {step.text}
                </Typography>
              </React.Fragment>
            );
          })}
        </Box>

        {/* ---------- Mobile/Tablet Timeline ---------- */}
        <Box
          sx={{
            display: { xs: "flex", md: "none" },
            flexDirection: "column",
            gap: 4,
            mt: 4,
            alignItems: "center",
          }}
        >
          {steps.map((step, index) => (
            <Box
              key={index}
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
                px: 2,
              }}
            >
              <Typography
                sx={{
                  fontSize: "42px",
                  fontWeight: 600,
                  fontFamily: "AllRoundGothic-Bold",
                  color: "#F2F3F0",
                  textShadow: "1px 1px 2px rgba(0,0,0,0.1)",
                  mb: 1,
                }}
              >
                {step.number}
              </Typography>
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: 500,
                  fontFamily: "Poppins",
                  color: "#003A26",
                  maxWidth: "260px",
                  lineHeight: "22px",
                }}
              >
                {step.text}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default SafetyTimeline;
